import script from "./Rastreio.vue?vue&type=script&setup=true&lang=js"
export * from "./Rastreio.vue?vue&type=script&setup=true&lang=js"

import "./Rastreio.vue?vue&type=style&index=0&id=047a9e4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047a9e4c"]])

export default __exports__